<template>
  <div>
    <button
      class="button is-info is-light is-small is-outline is-rounded"
      @click="confirmDeleteUnitGroupUnit(unitGroupUnitID, name)"
    >
      Delete
    </button>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    unitGroupUnitID: [Number, String],
    lotNumber: String,
    name: String,
    loadUpdateUnitGroupUnit: Function,
    confirmDeleteUnitGroupUnit: Function
  }
}
</script>
